import platform from "@/helper/platform";
import { RequestHelper } from "@/helper/requestHelper";
import { RegionHelper } from "@/helper/regionHelper";
import { News } from "@/data/news/news";
import { DebugHelper } from '@/helper/debugHelper';

export default class NewsApi {
    public getTopNews(): Promise<News[]> {
        return new Promise((resolve, reject) => {
            RequestHelper.get(
                "get_news_list",
                { platform: String(platform.id) },
                res => {
                    const data = JSON.parse(res).data;
                    DebugHelper.trace("get_news_list", data);
                    resolve(data.newsList);
                },
                reject
            );
        });
    }

    public paginate(
        nextIndex: number = 0
    ): Promise<{ news: News[]; hasNext: boolean }> {
        return new Promise((resolve, reject) => {
            const params = Object.assign(
                {
                    platform: String(platform.id),
                    region: RegionHelper.getRegion()
                },
                nextIndex ? { count: String(nextIndex) } : {}
            );
            RequestHelper.get(
                "get_news_list_all",
                params,
                res => {
                    const data = JSON.parse(res).data;
                    DebugHelper.trace("get_news_list_all", data);
                    resolve({ news: data.newsList, hasNext: data.next });
                },
                reject
            );
        });
    }
}
